<script lang="ts">
  import { currencyFormatter } from "../../helpers/localise";
  import TextNew from "../TextNew.svelte";

  type PriceChange = "increased" | "decreased" | "unchanged";

  export let title: string = "";
  export let totalSpend: number;
  export let prevPrice: number = 0;
  export let currPrice: number = 0;

  let priceChange: PriceChange;
  $: priceChange =
    currPrice > prevPrice ? "increased" : currPrice < prevPrice ? "decreased" : "unchanged";

  const priceChangeColors = {
    increased: "var(--rekki-error)",
    decreased: "var(--rekki-success)",
    unchanged: "var(--rk-text-low)",
  };
</script>

<div class="row">
  <div>
    <TextNew size="s">{title}</TextNew>
    <TextNew size="xs" --rk-text-color="var(--rk-text-low)"
      >{`${$currencyFormatter.format(totalSpend / 100)} spend in period`}
    </TextNew>
  </div>
  <div class="price-row">
    <TextNew size="s" --rk-text-color="var(--rk-text-low)"
      >{$currencyFormatter.format(prevPrice / 100)}</TextNew
    >
    <TextNew size="s" --rk-text-color={priceChangeColors[priceChange]}
      >{$currencyFormatter.format(currPrice / 100)}</TextNew
    >
  </div>
</div>

<style>
  .row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .price-row {
    display: flex;
    gap: 8px;
  }
</style>
